import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { submit } from 'redux-form'
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@material-ui/core'
import AdvertisementReduxForm from './AdvertisementForm'
import { placements } from '../../models/advertisements/AdvertisementModel'

function fromDetails (data = {}) {
  const selectedPlacements = Array.isArray(data.placement)
    ? data.placement
    : [data.placement].filter(value => value !== '' && value !== null && value !== undefined)

  return {
    name: data.name || '',
    description: data.description || '',
    targetUrl: data.targetUrl || '',
    order: data.order == null ? '' : data.order,
    validFrom: data.validFrom || null,
    validTo: data.validTo || null,
    tenantScope: data.tenantScope || [],
    placements: selectedPlacements.map(value => placements[value] ? placements[value].value : value),
    styles: data.styles || {}
  }
}

export default function AdvertisementDialog ({open, edit, loading, error, details, tenants, busy, onSubmit, onCancel, onRetry}) {
  const dispatch = useDispatch()

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth='md'
      onClose={busy ? undefined : onCancel}
    >
      <DialogTitle>{edit ? 'Edycja reklamy' : 'Nowa reklama'}</DialogTitle>
      <DialogContent>
        {loading ? (
          <CircularProgress />
        ) : error ? (
          <div>
            <Typography color='error'>
              Nie udało się pobrać danych formularza.
            </Typography>
            <Button onClick={onRetry}>Spróbuj ponownie</Button>
          </div>
        ) : (
          <AdvertisementReduxForm
            initialValues={fromDetails(details || {})}
            currentImage={details && details.mainImageUrl}
            tenants={tenants}
            busy={busy}
            onSubmit={onSubmit}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={busy}>
          Anuluj
        </Button>
        <Button
          variant='contained'
          color='primary'
          disabled={busy || loading || error}
          onClick={() => dispatch(submit('advertisementForm'))}
        >
          Zapisz
        </Button>
      </DialogActions>
    </Dialog>
  )
}

AdvertisementDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  edit: PropTypes.bool,
  loading: PropTypes.bool,
  error: PropTypes.bool,
  details: PropTypes.object,
  tenants: PropTypes.array.isRequired,
  busy: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onRetry: PropTypes.func.isRequired
}
